var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { ref: "slider", staticClass: "slider" },
      _vm._l(_vm.estates, function(estate) {
        return _c(
          "div",
          { key: estate.id },
          [
            _c("estate-card", {
              staticClass: "bg-white",
              attrs: { estate: estate }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.estates.length === 0
      ? _c(
          "div",
          { staticClass: "text-center flex items-center justify-center" },
          [_vm._v("Er konden geen panden gevonden worden.")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }